interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage' | 'CollectionPage';
  data: Record<string, unknown>;
}

export default function SEOSchema({ type, data }: SEOSchemaProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '色影视',
      url: 'https://www.seyingtv.com',
      description: '色影视提供电视剧全集在线观看、电影完整版播放、综艺全集免费看，不缓冲追剧连续播放，高清画质流畅体验。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-8888',
        contactType: 'customer service',
        email: 'contact@seyingtv.com',
        availableLanguage: ['Chinese'],
      },
      sameAs: [
        'https://www.seyingtv.com',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '色影视',
      url: 'https://www.seyingtv.com',
      description: '电视剧全集在线观看、电影完整版播放、综艺全集免费看，不缓冲追剧连续播放，高清画质流畅体验，最新影视剧集大全一网打尽。',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.seyingtv.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      inLanguage: 'zh-CN',
      isPartOf: {
        '@type': 'WebSite',
        name: '色影视',
        url: 'https://www.seyingtv.com',
      },
      ...data,
    },
    BreadcrumbList: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      inLanguage: 'zh-CN',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
    CollectionPage: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      inLanguage: 'zh-CN',
      ...data,
    },
  };

  const schema = { ...schemas[type], ...data };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}